export default __webpack_public_path__ + "static/media/recent-activity-artwork-3.16a6cfe5.png";